import { Injectable, Provider } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BannerState } from '../../../components/shared/banner/state/banner-state.model';
import { IBannerService, IBannerServiceToken } from './banner-service.interface';

@Injectable({
  providedIn: 'root'
})
export class BannerService implements IBannerService {
  private bannerStateSource: BehaviorSubject<BannerState | undefined> = new BehaviorSubject<BannerState | undefined>(undefined);
  private bannerStateChanged: Observable<BannerState | undefined>;

  public constructor() {
    this.bannerStateChanged = this.bannerStateSource.asObservable();
  }

  public bannerStateChangedGet(): Observable<BannerState | undefined> {
    return this.bannerStateChanged;
  }

  public bannerStateSet(bannerState?: BannerState | undefined): void {
    this.bannerStateSource.next(bannerState);
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BannerServiceProvider: Provider[] = [
  { provide: IBannerServiceToken, useExisting: BannerService }
];
